import { FC } from 'react'
import FeatureFlagsForm from './FeatureFlagsForm'

const FeatureFlags: FC = () => {
  return (
    <section>
      <FeatureFlagsForm />
    </section>
  )
}

export default FeatureFlags
